const game = document.getElementById("game");
const player = document.getElementById("player");
const menu = document.getElementById("menu");
const startBtn = document.getElementById("startBtn");

let caesar_img = [
  {
    v: "img/Caesar_v_1.png",
    l: "img/Caeser_l_1.png",
    r: "img/Caesar_r_1.png",
  },
  {
    v: "img/Caesar_v_2.png",
    l: "img/Caeser_l_2.png",
    r: "img/Caesar_r_2.png",
  },
  {
    v: "img/Caesar_v_3.png",
    l: "img/Caeser_l_3.png",
    r: "img/Caesar_r_3.png",
  },
];
let bild_index = 0;
let time_image_change = 100;

let offsetX = 0,
  offsetY = 0;
const speed = 4;
const keys = {};
let gameRunning = false;
let debugHitboxes = false;

// --- Tastatursteuerung
document.addEventListener("keydown", (e) => {
  if (gameRunning) keys[e.key] = true;
  if (e.key === "F2") {
    // Hitbox Toggle
    debugHitboxes = !debugHitboxes;
    updateHitboxVisibility();
  }
});
document.addEventListener("keyup", (e) => {
  if (gameRunning) keys[e.key] = false;
});

// --- Player Hitbox
function getPlayerHitbox() {
  const rect = player.getBoundingClientRect();
  return {
    left: rect.left + 80,
    right: rect.right - 80,
    top: rect.top + 120,
    bottom: rect.bottom - 1,
  };
}

// --- DEBUG Hitbox Overlay Player
const hitboxOverlay = document.createElement("div");
hitboxOverlay.style.position = "fixed";
hitboxOverlay.style.pointerEvents = "none";
hitboxOverlay.style.border = "4px solid red";
hitboxOverlay.style.zIndex = "100";
hitboxOverlay.style.width = "110px";
hitboxOverlay.style.height = "71px";

document.body.appendChild(hitboxOverlay);

function updatePlayerHitboxOverlay() {
  const h = getPlayerHitbox();
  hitboxOverlay.style.left = h.left - 110 + "px";
  hitboxOverlay.style.top = h.top - 71 + "px";
  hitboxOverlay.style.width = h.right - h.left + "px";
  hitboxOverlay.style.height = h.bottom - h.top + "px";
}

window.bushesData.forEach((b) => {
  const div = document.createElement("div");
  div.className = "bush";
  div.style.top = b.top + "px";
  div.style.left = b.left + "px";
  div.style.transform = `rotate(${b.rotate}deg)`;
  const img = document.createElement("img");
  img.src = "img/Busch.png";
  img.alt = "Busch";
  div.appendChild(img);
  game.appendChild(div);
});

// --- Texte generieren
const textData = [
  { top: 600, left: 1400, rotate: 0, text: "murus", IDD: "mauer" },
  { top: 1000, left: 1800, rotate: 0, text: "vinum", IDD: "Wein" },
  { top: 1000, left: 1800, rotate: 0, text: "amicus", IDD: "Freund" },
  { top: 1000, left: 1800, rotate: 0, text: "caesar", IDD: "Kaiser" },
  { top: 1000, left: 1800, rotate: 0, text: "frucctus", IDD: "Frucht" },
];

textData.forEach((b) => {
  const div = document.createElement("div");
  div.className = "text";
  div.style.top = b.top + "px";
  div.style.left = b.left + "px";
  div.style.transform = `rotate(${b.rotate}deg)`;
  div.id = b.text.toLowerCase();

  // Flexbox zentrieren
  div.style.display = "flex";
  div.style.justifyContent = "center"; // horizontal zentrieren
  div.style.alignItems = "center"; // vertikal zentrieren

  const h3 = document.createElement("h3");
  h3.textContent = b.text;
  h3.style.transform = `rotate(0deg)`;
  h3.style.fontSize = "4em";

  div.appendChild(h3);
  game.appendChild(div);
});

const bushes = document.querySelectorAll(".bush, .text");

// --- Kollision
function checkCollision(newX, newY) {
  const hitbox = getPlayerHitbox();
  game.style.transform = `translate(${newX}px,${newY}px)`;
  let collided = false,
    tolerance = 5;
  bushes.forEach((bush) => {
    const r = bush.getBoundingClientRect();
    if (
      hitbox.left < r.right - tolerance &&
      hitbox.right > r.left + tolerance &&
      hitbox.top < r.bottom - tolerance &&
      hitbox.bottom > r.top + tolerance
    )
      collided = true;
  });
  bushes.forEach((text) => {
    const r = text.getBoundingClientRect();
    if (
      hitbox.left < r.right - tolerance &&
      hitbox.right > r.left + tolerance &&
      hitbox.top < r.bottom - tolerance &&
      hitbox.bottom > r.top + tolerance
    )
      collided = true;
  });
  game.style.transform = `translate(${offsetX}px,${offsetY}px)`;
  return collided;
}

// --- DEBUG HITBOXEN Toggle
function updateHitboxVisibility() {
  if (debugHitboxes) {
    hitboxOverlay.style.display = "block";
    textData.forEach((b) => {
      const el = document.getElementById(b.text.toLowerCase());
      if (el) el.style.outline = "3px solid cyan";
    });
    bushes.forEach((b) => {
      b.style.outline = "2px solid lime";
    });
  } else {
    hitboxOverlay.style.display = "none";
    textData.forEach((b) => {
      const el = document.getElementById(b.text.toLowerCase());
      if (el) el.style.outline = "none";
    });
    bushes.forEach((b) => {
      b.style.outline = "none";
    });
  }
}

updateHitboxVisibility(); // Initiale Anzeige

// --- GameLoop
function gameLoop() {
  if (gameRunning) {
    let newX = offsetX,
      newY = offsetY;
    if (keys["ArrowUp"]) newY += speed;
    if (keys["ArrowDown"]) newY -= speed;
    if (keys["ArrowLeft"]) newX += speed;
    if (keys["ArrowRight"]) newX -= speed;
    if (!checkCollision(newX, newY)) {
      offsetX = newX;
      offsetY = newY;
      game.style.transform = `translate(${offsetX}px,${offsetY}px)`;
    }
  }
  if (debugHitboxes) updatePlayerHitboxOverlay();
  requestAnimationFrame(gameLoop);
}

// --- Player Bildwechsel
function img_change() {
  if (keys["ArrowDown"]) {
    bild_index = (bild_index + 1) % 3;
    document.getElementById("caesar_p").src = caesar_img[bild_index].v;
  } else if (keys["ArrowUp"]) {
    document.getElementById("caesar_p").src = "img/Caesar_h_1.png";
  } else if (keys["ArrowLeft"]) {
    bild_index = (bild_index + 1) % 3;
    document.getElementById("caesar_p").src = caesar_img[bild_index].l;
  } else if (keys["ArrowRight"]) {
    bild_index = (bild_index + 1) % 3;
    document.getElementById("caesar_p").src = caesar_img[bild_index].r;
  } else {
    document.getElementById("caesar_p").src = caesar_img[0].v;
  }
}

startBtn.addEventListener("click", () => {
  menu.style.display = "none";
  gameRunning = true;
});

requestAnimationFrame(gameLoop);
setInterval(img_change, time_image_change);

// --- Buch Overlay + Vokabeln
const helpIcon = document.getElementById("helpIcon");
const bookOverlay = document.getElementById("bookOverlay");
const closeBook = document.getElementById("closeBook");
const vocabList = [
  { question: "amicus", answer: "Freund" },
  { question: "puer", answer: "Junge" },
  { question: "puella", answer: "Mädchen" },
  { question: "vinum", answer: "Wein" },
  { question: "caesar", answer: "Kaiser" },
  { question: "murus", answer: "Mauer" },
  { question: "frucctus", answer: "Frucht" },
  { question: "pilum", answer: "Pfeil" },
];
const vocabDiv = document.getElementById("vocabList");
const answerDiv = document.getElementById("answerList");
const checkAllBtn = document.getElementById("checkAllAnswers");
const feedback = document.getElementById("feedback");

vocabList.forEach((v, i) => {
  const p = document.createElement("p");
  p.textContent = v.question;
  vocabDiv.appendChild(p);
  const input = document.createElement("input");
  input.classList.add("border", "border-slate-400", "block");
  input.type = "text";

  input.dataset.index = i;
  answerDiv.appendChild(input);
});

helpIcon.addEventListener("click", () => {
  bookOverlay.style.display = "flex";
  gameRunning = false;
});
closeBook.addEventListener("click", () => {
  bookOverlay.style.display = "none";
  gameRunning = true;
  feedback.textContent = "";
  answerDiv.querySelectorAll("input").forEach((inp) => (inp.value = ""));
});
bookOverlay.addEventListener("click", (e) => {
  if (e.target === bookOverlay) {
    bookOverlay.style.display = "none";
    gameRunning = true;
    feedback.textContent = "";
    answerDiv.querySelectorAll("input").forEach((inp) => (inp.value = ""));
  }
});

// --- Check Button
checkAllBtn.addEventListener("click", () => {
  let correct = true;
  answerDiv.querySelectorAll("input").forEach((inp) => {
    const idx = parseInt(inp.dataset.index);
    if (
      inp.value.trim().toLowerCase() === vocabList[idx].answer.toLowerCase()
    ) {
      inp.style.borderColor = "green";
      document.getElementById(
        vocabList[idx].question.toLowerCase(),
      ).style.display = "none";
    } else {
      inp.style.borderColor = "red";
      correct = false;
    }
  });
  feedback.textContent = correct
    ? "Alles richtig!"
    : "Einige Antworten falsch.";
  feedback.style.color = correct ? "green" : "red";
});

// --- Controller Gamepad
const btnUp = document.getElementById("up");
const btnDown = document.getElementById("down");
const btnLeft = document.getElementById("left");
const btnRight = document.getElementById("right");

function pressKey(key, pressed) {
  keys[key] = pressed;
}

[btnUp, btnDown, btnLeft, btnRight].forEach((btn) => {
  const keyMap = {
    up: "ArrowUp",
    down: "ArrowDown",
    left: "ArrowLeft",
    right: "ArrowRight",
  };
  const k = keyMap[btn.id];
  btn.addEventListener("mousedown", () => pressKey(k, true));
  btn.addEventListener("mouseup", () => pressKey(k, false));
  btn.addEventListener("mouseleave", () => pressKey(k, false));
  btn.addEventListener("touchstart", () => pressKey(k, true));
  btn.addEventListener("touchend", () => pressKey(k, false));
});
